<template>
  <b-nav id="nav-drawer" tabs vertical class="w-20">
    <b-nav-item :to="{ name: 'AdminDashboard' }" exact-active-class="active">Dashboard</b-nav-item>
    <b-nav-item :to="{ name: 'Users' }" exact-active-class="active">Users</b-nav-item>
    <b-nav-item :to="{ name: 'Messages' }" exact-active-class="active">Messages</b-nav-item>
    <b-nav-item :to="{ name: 'Organizations' }" exact-active-class="active">Organizations</b-nav-item>
    <b-nav-item :to="{ name: 'Actuators' }" exact-active-class="active">Actuators</b-nav-item>
    <b-nav-item :to="{ name: 'Valves' }" exact-active-class="active">Valves</b-nav-item>
    <b-nav-item :to="{ name: 'Kits' }" exact-active-class="active">Kits</b-nav-item>
    <b-nav-item :to="{ name: 'Materials' }" exact-active-class="active">Kit Materials</b-nav-item>
    <b-nav-item :to="{ name: 'Options' }" exact-active-class="active">Kit Options</b-nav-item>
    <b-nav-item :to="{ name: 'Documents' }" exact-active-class="active">Documents</b-nav-item>
  </b-nav>
</template>

<script>
export default {
  name: 'NavDrawer',
  data () {
    return {
      toggle: true
    }
  }
}
</script>

<style>
  #nav-drawer {
    height: calc(100vh - 4rem);
  }

  .nav {
    background: #ffffff;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/layouts/components/NavDrawer.vue